import axios from "axios";
import segments from "./segments";

const OAuthRequest = axios.create({
    // baseURL: `${segments.host}/`,
    // baseURL: `https://apitest.yzcfs.cn/`,
    baseURL: 'https://api.yzcfs.cn/',
    timeout: 10000000,
});

OAuthRequest.interceptors.response.use(
    (response) => {
        if (parseInt(response.status) === 200 && parseInt(response.data.code) === 1) {
            return response.data;
        }
        return Promise.reject(response.data);
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Login
const OAuthLogin = (params) => {
    return OAuthRequest.post(segments.urlAss + "/login", params);
};

// Logout
const OAuthLogout = (access_token) => {
    return OAuthRequest.request({
        headers: { Authorization: "Bearer " + access_token },
        method: "get",
        url: segments.urlAss + "/logout",
    });
};

// Update Password
const OAuthUpdatePassword = (access_token, data) => {
    return OAuthRequest.request({
        headers: { Authorization: "Bearer " + access_token },
        method: "put",
        url: segments.urlAss + "/profile/updatePassword",
        data: data,
    });
};

// Load captcha
const OAuthCaptcha = () => {
    return OAuthRequest.request({
        method: "get",
        url: segments.urlAss + "/captcha",
    });
};

const OAuthBindPhone = (access_token, data) => {
    return OAuthRequest.request({
        headers: { Authorization: "Bearer " + access_token },
        method: "put",
        url: segments.urlAss + "/profile/bindPhone",
        data: data,
    });
};
export { OAuthLogin, OAuthLogout, OAuthCaptcha, OAuthUpdatePassword,OAuthBindPhone };

// 登录获取UUID
export const getAccountToken = () =>
    OAuthRequest.request({
        method: "get",
        url: "/bms-api/recover-account/token",
     });
 // 获取验证码
export const getAccountSms = (params) =>
    OAuthRequest.request({
        method: "get",
        url: segments.urlAss + "/recover-account/sms",
        params: params,
     });
 // 提交找回请求
 export const getAccountPassword = (data) =>
    OAuthRequest.request({
        method: "post",
        url: segments.urlAss + "/recover-account/password",
        data: data,
     });
